<astral-masked-input [control]="control" [helpText]="helpText" [mask]="mask" [maskFormat]="maskFormat"></astral-masked-input>
